//import { NavLink } from "react-router-dom";
import nameLogo from "../assets/images/RajalakshmiLogo.jpg";
import HeaderFooterNav from "./HeaderFooterNav";
import classes from "../styles/RootLayout.module.css";

export default function Header() {
  return (
    <>
      <div className={classes["logo-brand-container"]}>
        <img
          src={nameLogo}
          alt="NameLogo"
          className={classes["rounded-logo"]}
        />
        <h2>RA$HMI</h2>
      </div>
      {/* <div>
        <NavLink
          to="/"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
          end
        >
          Home
        </NavLink>
        <NavLink
          to="/AboutMe"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          Get to know me
        </NavLink>
        <NavLink
          to="/MyProjects"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          My Web Lab
        </NavLink>
        <NavLink
          to="/MyArtWorks"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          Visit the Artist in Me
        </NavLink>
        <NavLink
          to="/ContactMe"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          Contact Me
        </NavLink>
      </div> */}
      <div>
        <HeaderFooterNav />
      </div>
    </>
  );
}
